// extracted by mini-css-extract-plugin
module.exports = {"componentMenuTransitionDelay":"20ms","componentMenuTransitionDuration":"180ms"};